import '.ac{position:relative;}.ssr-plugin'
import '.l{width:100%;}.ssr-plugin'
import '.is{min-height:200px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.ai{justify-content:center;}.ssr-plugin'
import '.aq{align-items:flex-start;}.ssr-plugin'
import '.er{padding:2rem;}.ssr-plugin'
import '.e1{background:var(--palette-white);}.ssr-plugin'
import '.c2{overflow:hidden;}.ssr-plugin'
import '.be{position:absolute;}.ssr-plugin'
import '.lp{top:50%;}.ssr-plugin'
import '.i0{right:1rem;}.ssr-plugin'
import '.lq{transform:translateY(-50%);}.ssr-plugin'
import '.lr{width:120px;}.ssr-plugin'
import '.ls{height:120px;}.ssr-plugin'
import '.lt{z-index:0;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.ee{z-index:1;}.ssr-plugin'
import '.u{gap:0.5rem;}.ssr-plugin'
import '.lu{max-width:calc(100% - 140px);}.ssr-plugin'
import '.lv{font-size:4rem;}.ssr-plugin'
import '.cl{font-weight:700;}.ssr-plugin'
import '.le{line-height:100%;}.ssr-plugin'
import '.ix{margin:0px;}.ssr-plugin'
import '.a3{color:var(--brand-secondary);}.ssr-plugin'
import '.a4{font-family:FunnelDisplay;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="ac l is d e ai aq er e1 c2"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="be lp i0 lq lr ls lt d t ai"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="ac ee d e aq u lu"
      >
        <div className="lv cl le ix a3 a4"
        >
          {number}
        </div>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--brand-secondary)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
